module.exports = "img/14.98ca55.webp";